// extracted by mini-css-extract-plugin
export default {"block":"UserInfo_block__FHaNK","text":"UserInfo_text__V6VLq","btn":"UserInfo_btn__WzLry","icon":"UserInfo_icon__c8VrM","userinfo":"UserInfo_userinfo__TmHa8"};